import axios from "axios";

async function getCountryList(toSelected = false) {
  let countries = [];

  if (toSelected) {
    countries.push({ id: 0, name: "Todos" });
  }

  try {
    const response = await axios({
      method: "get",
      url: "https://console.vecinos360.com/web_service/ws.extras.php?ent=3",
    });

    const data = response.data?.datos;
    data.forEach((country, index) => {
      countries.push({
        id: index + 1,
        alpha2code: country.alpha2Code,
        alpha3code: country.alpha3Code,
        name: country.pais,
        calling_code: country.callingCodes.toString(),
      });
    });
    return countries;
  } catch (error) {
    console.error("Error fetching country list:", error);
  }

  return countries;
}

async function getCityList(countryCode) {
  if (!countryCode) {
    return [];
  }

  let cities = [];

  try {
    const response = await axios({
      method: "get",
      url: "https://console.vecinos360.com/web_service/ws.extras.php?ent=4&iso=" + countryCode,
    });

    const data = response.data?.datos;
    for (const key in data) {
      cities.push(data[key]);
    }

    return cities;
  } catch (error) {
    console.error("Error fetching city list:", error);
  }

  return cities;
}

export { getCountryList, getCityList };
